/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

jQuery(document).ready(function(){
  if(window.innerWidth < 1200){
    jQuery('ul.mobile-nav.mobile-nav--weight-normal').eq(0).after(jQuery('form#LocalizationForm-sections--22882574172462__footer'))
  }
  else{
    jQuery('.track-my-order').eq(0).parent().before(jQuery('form#LocalizationForm-sections--22882574172462__footer'))
  }

  if(window.innerWidth < 768){
    $('.two-tab__tabs-item').on('click', function() {
    var $container = $(this).parent();
    var $element = $(this);
    var windowWidth = $(window).width();
    var containerOffset = $container.offset().left;
    var elementOffset = $element.offset().left;
    var elementWidth = $element.outerWidth();

    var scrollPosition = elementOffset - containerOffset - (windowWidth / 2) + (elementWidth / 2);

    $container.animate({
        scrollLeft: $container.scrollLeft() + scrollPosition
    }, 500);  // Adjust the duration as needed
});
  }

  
$('div[class*="product-toggles-item-template"]:eq(0)').click(function(){
  jQuery('.two-tab__tabs-item').eq(0).click()
}); 


$('div[class*="product-toggles-item-template"]:eq(1)').click(function(){
  jQuery('.two-tab__tabs-item').eq(1).click()
}); 



$('div[class*="product-toggles-item-template"]:eq(2)').click(function(){
  jQuery('.two-tab__tabs-item').eq(2).click()
}); 


$('div[class*="product-toggles-item-template"]').eq(3).click(function(e){
  e.preventDefault();
  e.stopImmediatePropagation();
  jQuery('.two-tab__tabs-item').eq(3).click()
}); 


});
  





  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
